/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ project: NonNullable<unknown> }} Explorer_Info_Batch_Error_No_GroupsInputs */

const en_explorer_info_batch_error_no_groups = /** @type {(inputs: Explorer_Info_Batch_Error_No_GroupsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.project}: no valid event groups`)
};

const fr_explorer_info_batch_error_no_groups = /** @type {(inputs: Explorer_Info_Batch_Error_No_GroupsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.project}: aucun groupe d'événements valide`)
};

const de_explorer_info_batch_error_no_groups = /** @type {(inputs: Explorer_Info_Batch_Error_No_GroupsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.project}: Keine gültigen Ereignisgruppen`)
};

const it_explorer_info_batch_error_no_groups = /** @type {(inputs: Explorer_Info_Batch_Error_No_GroupsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.project}: nessun gruppo di eventi valido`)
};

const ru_explorer_info_batch_error_no_groups = /** @type {(inputs: Explorer_Info_Batch_Error_No_GroupsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.project}: отсутствуют действительные группы событий`)
};

const es_explorer_info_batch_error_no_groups = /** @type {(inputs: Explorer_Info_Batch_Error_No_GroupsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.project}: no hay grupos de eventos válidos`)
};

const zh_cn2_explorer_info_batch_error_no_groups = /** @type {(inputs: Explorer_Info_Batch_Error_No_GroupsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.project}：没有有效的事件组`)
};

const ja_explorer_info_batch_error_no_groups = /** @type {(inputs: Explorer_Info_Batch_Error_No_GroupsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.project}: 有効なイベントグループがありません`)
};

const hi_explorer_info_batch_error_no_groups = /** @type {(inputs: Explorer_Info_Batch_Error_No_GroupsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.project}: कोई वैध इवेंट समूह नहीं`)
};

const pt_pt2_explorer_info_batch_error_no_groups = /** @type {(inputs: Explorer_Info_Batch_Error_No_GroupsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.project}: nenhum grupo de eventos válido`)
};

/**
* | output |
* | --- |
* | "{project}: no valid event groups" |
*
* @param {Explorer_Info_Batch_Error_No_GroupsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_batch_error_no_groups = /** @type {((inputs: Explorer_Info_Batch_Error_No_GroupsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Batch_Error_No_GroupsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_info_batch_error_no_groups(inputs)
	if (locale === "de") return de_explorer_info_batch_error_no_groups(inputs)
	if (locale === "it") return it_explorer_info_batch_error_no_groups(inputs)
	if (locale === "ru") return ru_explorer_info_batch_error_no_groups(inputs)
	if (locale === "es") return es_explorer_info_batch_error_no_groups(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_info_batch_error_no_groups(inputs)
	if (locale === "ja") return ja_explorer_info_batch_error_no_groups(inputs)
	if (locale === "hi") return hi_explorer_info_batch_error_no_groups(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_info_batch_error_no_groups(inputs)
	return en_explorer_info_batch_error_no_groups(inputs)
});